export const MESSAGE_TYPE = {
  user: "user",
  clinician: "clinician",
  system: "system",
  event: "event",
} as const;

export const SENDER_TYPE = {
  user: "User",
  admin: "Admin",
  system: null,
} as const;
